var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamIdeaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "team-idea"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.375 21.103C4.82475 21.103 6 19.9278 6 18.478C6 17.0283 4.82475 15.853 3.375 15.853C1.92525 15.853 0.75 17.0283 0.75 18.478C0.75 19.9278 1.92525 21.103 3.375 21.103Z",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M6.581 23.1998C5.02592 21.6194 2.55143 21.4073 0.75 22.6998",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.625 21.103C22.0747 21.103 23.25 19.9278 23.25 18.478C23.25 17.0283 22.0747 15.853 20.625 15.853C19.1753 15.853 18 17.0283 18 18.478C18 19.9278 19.1753 21.103 20.625 21.103Z",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M17.5107 23.1051C19.0764 21.6052 21.489 21.4349 23.2497 22.7001",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.103C13.864 21.103 15.375 19.592 15.375 17.728C15.375 15.8641 13.864 14.353 12 14.353C10.136 14.353 8.625 15.8641 8.625 17.728C8.625 19.592 10.136 21.103 12 21.103Z",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    d: "M14.7231 23.25C13.0292 22.397 11.0334 22.387 9.33105 23.223",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7496 4.59987C15.7501 2.72683 14.3684 1.14068 12.513 0.884244C10.6576 0.627813 8.89751 1.77975 8.38992 3.5827C7.88234 5.38565 8.78293 7.28665 10.4996 8.03587V9.85287H13.4996V8.03587C14.8664 7.44019 15.75 6.09084 15.7496 4.59987V4.59987Z",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5",
    d: "M10.5 12.103H13.5",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6",
    d: "M19.8105 5.25H21.3105",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_7",
    d: "M19.5 8.68896L20.561 9.74996",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_8",
    d: "M19.5 1.81L20.561 0.75",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_9",
    d: "M4.18945 5.25H2.68945",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_10",
    d: "M4.50045 8.68896L3.43945 9.74996",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_11",
    d: "M4.50045 1.81L3.43945 0.75",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIdeaIcon);
export default __webpack_public_path__ + "static/media/teamIdeaIcon.c52858c112611a3494221b1efac8ceae.svg";
export { ForwardRef as ReactComponent };